import {createContext} from 'react'
import {getApi} from "@/utils/request";
import {getAccountList} from "@/services/accountApi";
import {getMessageStatus} from "@/services/homeApi";
import {message, Modal} from "antd";
import {getAuthStatus} from "@/services/userApi";
import {history} from "@umijs/max";

export const LayoutContext = createContext('')

// 获取账户列表
export const fetchAccountList = async()=>{
    try {
        const data = await getApi({ api: getAccountList });
        return data?.map(item => ({
            ...item,
            label: item.name,
            value: item.account,
        }))
    } catch (error) {
        console.error("获取账户列表失败:", error);
    }
}

// 获取站内全部数据状态
export const getAllStatus = async (setInitialState) => {
    try {
        const response = await getMessageStatus();
        if (response.status){
            setInitialState((prevState) => {
                if (!prevState) return prevState;
                return {
                    ...prevState,
                    currentUser: {
                        ...(prevState.currentUser || {}),
                        messageAllStatus: response.data
                    },
                };
            });
        } else {
            message.error('操作失败，请重试');
        }
    } catch (error) {
        console.error(error);
        message.error(`操作失败:${error}`);
    }
}
// 认证状态常量
const AUTH_STATUS = {
    UNAUTHENTICATED: 1,
    APPROVED: 2,
} as const;

export const getAuthenticationStatus = async (): Promise<number | null> => {
    try {
        const response = await getAuthStatus();
        if (response.status) {
            return response.data.status;
        }
        return null;
    } catch (error) {
        console.error('获取认证状态失败:', error);
        message.error('获取认证状态失败，请稍后重试');
        return null;
    }
};
// 检查认证状态并处理未认证情况
export const checkAuthStatus = async (): Promise<boolean> => {
    const status = await getAuthenticationStatus();
    if (status !== AUTH_STATUS.APPROVED) {
        const result = Modal.confirm({
            content: '提现时需先完成实名认证后再进行提现',
            okText: '去认证',
            cancelText: '取消'
        });

        if (result) {
            history.push('/account/reaNameAuthentication');
        }
        return false;
    }
    return true;
};
